"use client";

import { motion } from "framer-motion";
import { Autoplay, EffectCoverflow } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import Image from "next/image";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/css";
import "swiper/css/effect-cards";

import Link from "next/link";
import { Button } from "@/components/ui/button";

const uniqueImages = [
  {
    src: "/images/segment/road.jpg",
    alt: "men crossing road",
  },
  {
    src: "/images/segment/football.jpg",
    alt: "football players",
  },
  {
    src: "https://depot.moondream.ai/seg/kimera037.jpg",
    alt: "Kimera sports car",
  },
  {
    src: "https://depot.moondream.ai/seg/bird1.jpeg",
    alt: "beautiful bird",
  },
  {
    src: "https://depot.moondream.ai/seg/train1.jpeg",
    alt: "train engine",
  },
];

// Duplicate for smooth looping with coverflow effect
const images = [...uniqueImages, ...uniqueImages];

const css = `
  .mySwiperHero210 {
    width: 100%;
    height: 420px;
    padding-bottom: 50px;
  }
  
  .mySwiperHero210 .swiper-slide {
    background-position: center;
    background-size: cover;
    width: 300px;
  }
  
  .mySwiperHero210 .swiper-slide img {
    display: block;
    width: 100%;
  }
  
  .swiper-3d .swiper-slide-shadow-left {
    background-image: none;
  }
    
  .swiper-3d .swiper-slide-shadow-right{
    background: none;
  }
`;

export default function SegmentingHero() {
  return (
    <section className="pt-8 sm:pt-20">
      <style>{css}</style>
      <div className="container mx-auto px-0 sm:px-8">
        <div className="mx-auto flex max-w-3xl flex-col items-center justify-center gap-4 px-8 sm:px-0">
          <h1
            className="text-center text-5xl lg:text-7xl tracking-[-0.01em]"
            style={{ fontFamily: 'var(--font-instrument-serif)' }}
          >
            The New Standard in Open&#8209;World Segmentation
          </h1>
          <p className="text-muted-foreground text-center lg:text-lg">
            Moondream Segmentation turns text prompts, points, or boxes into pixel-perfect SVG masks. State-of-the-art segmentation, available today in Moondream Cloud.
          </p>
          <div className="flex flex-wrap items-center justify-center gap-3">
            <Button asChild size="lg" className="rounded-full px-6 py-3">
              <Link href="/c/playground?skill=segment">Try Segmentation</Link>
            </Button>
            <Button
              asChild
              variant="outline"
              size="lg"
              className="rounded-full px-6 py-3"
            >
              <a
                href="https://docs.moondream.ai/skills/segment"
                target="_blank"
                rel="noreferrer"
              >
                View docs
              </a>
            </Button>
          </div>
        </div>

        <div className="relative mt-12 h-[420px] w-full lg:px-20">
          <div className="from-background md:w-58 sm:via-background absolute left-0 z-10 h-full w-12 bg-gradient-to-r to-transparent lg:left-16" />
          <div className="from-background md:w-58 sm:via-background absolute right-0 z-10 h-full w-12 bg-gradient-to-l to-transparent lg:right-16" />
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.3 }}
            className="w-full"
          >
            <Swiper
              autoplay={{
                delay: 3000,
                disableOnInteraction: false,
              }}
              effect="coverflow"
              grabCursor
              slidesPerView="auto"
              centeredSlides
              loop
              coverflowEffect={{
                rotate: 50,
                stretch: 0,
                depth: 100,
                modifier: 1,
                slideShadows: true,
              }}
              className="mySwiperHero210"
              modules={[EffectCoverflow, Autoplay]}
            >
              {images.map((image, index) => (
                <SwiperSlide key={index}>
                  <Image
                    className="h-full w-full overflow-hidden rounded-3xl object-cover shadow-lg"
                    src={image.src}
                    alt={image.alt}
                    width={300}
                    height={420}
                  />
                </SwiperSlide>
              ))}
            </Swiper>
          </motion.div>
        </div>
      </div>
    </section >
  );
}
